// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RhQ4W","col":"styles_col__2DRRc"};